import TerminatedDone from './TerminatedDone';

export default TerminatedDone;